import { FC } from 'react';
import { Link, Text } from '@gravity-ui/uikit';
import { sharePanelT } from '../../../i18n';

type InsertionInfoParams = {
    activeTab?: string;
};

export const InsertionInfo: FC<InsertionInfoParams> = ({ activeTab }) => {
    return (
        <>
            {activeTab == 'wiki' || activeTab == 'wikiMarkdown' ? (
                <Text whiteSpace="break-spaces">
                    {sharePanelT('wikiInterfaceInfo')}&nbsp;
                    <Link href="https://clubs.at.yandex-team.ru/mag/75190" target="_blank">
                        {sharePanelT('post')}
                    </Link>
                </Text>
            ) : null}
        </>
    );
};
